const PRICE_FACET_NAME = "Price";

var __isp_options = {
    isp_mobile_filters_options: {
        num_of_facets_visible: 100,
        filter_close_btn_text: "",
        num_filter_open_by_default: 15,
    },
    isp_serp_callback: function (data) {
        $('.button.isp_custom_price_submit').text("Go!");

        $(".separator_line").remove();
        $("#isp_search_results_filter_tags .isp_filter_tag_remove_all, #isp_search_results_filter_tags .isp_filter_removable_tag").each(function (index) {
            if (index !== $("#isp_search_results_filter_tags .isp_filter_tag_remove_all, #isp_search_results_filter_tags .isp_filter_removable_tag").length - 1) {
                $(this).after('<span class="separator_line">/</span>');
            }
        });

        $('.isp_facet_value_name_selected').each(function () {
            $(this).parents(".isp_facet_value").addClass("selected");
        });

        $(".isp_facet_title").css("background-image", 'none');

        var searchText = ISP_LAST_SEARCH.search_term;
        var numOfResults = ISP_LAST_SEARCH.total_results;


        $('.page__title').html('SEARCH RESULTS');
        if ($(".expand-symbol").length === 0) {
            $('.isp_facet_title').append('<div class="expand-symbol">+</div>');
        }

        $('.isp_facet_title').click(function () {
            $(this).css("background-image", 'none');

            if ($(this).parent().hasClass('collapsed')) {
                $(this).find('.expand-symbol').text('+');

            } else {
                $(this).find('.expand-symbol').html('&ndash;');
            }
        });

        $(".isp_product_price_wrapper").each(function () {
            if ($(this).find(".isp_compare_at_price").length > 0) {
                $(this).append($(this).find(".isp_compare_at_price"))
            }
        });


        if (window.location.href.indexOf("collections/") > -1) {
            $("span.isp_header_collection_title").text($("span.collection_title").text());
            $('#isp_center_container .isp_center_container_header div.isp_results_summary_wrapper h1').hide();
        } else {
            $('span#isp_results_search_text').html('Showing ' + numOfResults + ' results for ' + '"' + searchText + '".');
        }

        //Create custom page info on the to of the search page (mobile only)
        if ($('.mobile-page-info-container').length === 0) {
            const header = getNewMobileHeaderHTML(data);
            $(".isp_center_container_header").prepend(header);
        }

        //Adjust landing page size
        if (window.location.href.indexOf("/landing-page") > -1) {
            $("section.page__content")[0].style = "padding: 0px !important;"
        }

        //move removable tags to the top of the container
        $('div#isp_results_did_you_mean').before($('div#isp_search_results_filter_tags'));

        //mobile filters new markup
        setNewMobileFilters();
    },
    isp_serp_no_results_callback: function () {
        $('.rte>div').css("margin-bottom", "-140px")
    },
    isp_pre_serp_callback: function (data) {
        if (data.facets) {
            sortFacets(data.facets)
        }
    }
};

function sortFacets(facets) {
    for (const facet of facets) {
        if (facet[0].includes(PRICE_FACET_NAME)) {
            continue;
        }

        facet[1] = facet[1].sort((x, y) => {
            if (x[1] > y[1]) {
                return -1;
            } else if (x[1] < y[1]) {
                return 1;
            }
            return 0;
        })
    }
}

function getNewMobileHeaderHTML(data) {
    const title = window.location.href.indexOf("collections/") > -1 ? $(".collection_title").text() : ISP_LAST_SEARCH["search_term"];
    const totalResults = data.total_results;
    let retHTML = '<div class="mobile-page-info-container">';
    retHTML += `<span class="mobile-title">${title}</span>`;
    retHTML += `<button class="mobile-open-filters-btn" onclick="openMobileFilters(event, this)"></button>`;
    retHTML += `<span class="mobile-total-results-count">${totalResults} Results</span>`;
    retHTML += `</div>`;

    return retHTML;
}

function openMobileFilters(event, element) {
    setNewMobileFilters();
    ispRefineSectionDisplay(event, element);
}

function setNewMobileFilters() {
    //Use custom sort by
    const customSortBy = new ispCustomSortBy(ISP_LAST_SEARCH["sort_by"]);
    customSortBy.appendToFilters();

    $(".isp_single_mobile_facet.swatch_filter").each(function (index) {
        if (index < 4) {
            $(this).addClass("firstRow");
        }
    });

    $(".close_filters_btn").text("");

    if ($(".custom-swatch-container").length === 0) {
        $(".swatch_filter").wrapAll('<div class="custom-swatch-container"></div>');
    }
}